import Axios from 'axios';

import { API_URL_SUMMARY_LAMBDAS, getMaybeAuthServiceUserMetadataUrl, USE_AUTH_SERVICE } from '../config/Environment';

import type { UserMetadataRequestPayload, UserMetadataResponsePayload } from '@navina/api-types';
import type { AxiosResponse } from 'axios';

interface FetchUserMetadataArgs {
	readonly idToken: string;
	readonly dataSourceId: string;
	readonly emrEncounterId?: string;
	readonly unityPatientId?: string;
	readonly emrPatientId?: string;
}

export async function fetchUserMetadata({
	idToken,
	dataSourceId,
	emrEncounterId,
	unityPatientId,
	emrPatientId,
}: FetchUserMetadataArgs): Promise<AxiosResponse<UserMetadataResponsePayload>> {
	const maybeAuthServiceUrl = USE_AUTH_SERVICE === 'true' ? getMaybeAuthServiceUserMetadataUrl() : null;
	const path = maybeAuthServiceUrl ?? `${API_URL_SUMMARY_LAMBDAS}v2/getUserMetadata`;

	return Axios.post<UserMetadataResponsePayload>(
		path,
		{
			emrEncounterId,
			dataSourceId,
			unityPatientId,
			emrPatientId,
		} as const satisfies UserMetadataRequestPayload,
		{
			headers: {
				authorizationToken: `Bearer ${idToken}`,
				type: 'TOKEN',
				'content-type': 'application/json',
			},
		},
	);
}
